import { render } from "./PromotionsSlim.vue?vue&type=template&id=5d72306c&scoped=true"
import script from "./PromotionsSlim.vue?vue&type=script&lang=js"
export * from "./PromotionsSlim.vue?vue&type=script&lang=js"

import "./PromotionsSlim.vue?vue&type=style&index=0&id=5d72306c&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\front-on\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d72306c"]])

export default __exports__